import React, { useEffect, useState } from "react";

import Layout from "../../../layout";

import { Link } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

const RegiaoVendedorListar = () => {
  const [state, setState] = useState([]);

  const carregarDados = async () => {
    try {
      showLoading(".ibox-content");

      const requisicao = await api.get("/regiao-vendedor");

      const { data } = requisicao;
console.log(data);
      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      setState(data.data);
      window.$("#table-regiao-vendedor").footable();
      showLoading(".ibox-content");
    } catch (error) {
      console.log(error);
      showLoading(".ibox-content");
      danger("Erro ao carregar os dados das regiões x vendedores");
    }
  };

  useEffect(() => carregarDados(), []);

  const excluirRegiaoVendedor = (regiaoVendedor) => {
    window.swal(
      {
        title: "Você tem certeza?",
        text: `Deseja realmente excluir a região x vendedor?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        closeOnConfirm: true,
      },
      async () => {
        try {
          const { data } = await api.delete(
            `/regiao-vendedor/${regiaoVendedor.id}`
          );

          if (!data.status) {
            danger(data.mensagem);
            return;
          }

          success(data.mensagem);

          carregarDados();
        } catch (error) {
          console.log(error);
          danger("Erro ao deletar a regiao x vendedor");
        }
      }
    );
  };

  return (
    <>
      <Layout
        titulo="Ibraflex - Regiões x Vendedores"
        header="Listagem de Regiões x Vendedores"
        action={{ titulo: "Cadastrar", link: "/regiao-vendedor/cadastrar" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox">
              <div className="ibox-title">
                <h5>Listagem das regiões x vendedores cadastradas</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                {state.length <= 0 ? (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-regiao-vendedor"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Vendedor</th>
                          <th>Região</th>
                          <th>Descrição</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                    </table>
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-regiao-vendedor"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Vendedor</th>
                          <th>Região</th>
                          <th>Descrição</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {state.map((regiaoVendedor) => (
                          <tr key={regiaoVendedor.id}>
                            <td>{regiaoVendedor.id}</td>
                            <td>{regiaoVendedor.vendedor.nome}</td>
                            <td>{regiaoVendedor.regiao.descricao}</td>
                            <td>{regiaoVendedor.descricao}</td>
                            
                            <td>
                              <div className="btn-group">
                                <button
                                  data-toggle="dropdown"
                                  className="btn btn-success btn-xs dropdown-toggle"
                                >
                                  Opções
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <Link
                                      to={{
                                        pathname: "/regiao-vendedor/editar",
                                        state: { id: regiaoVendedor.id },
                                      }}
                                      className="dropdown-item"
                                      id="editar"
                                    >
                                      Editar
                                    </Link>
                                  </li>
                                  <li>
                                    <a
                                      href="#!"
                                      className="dropdown-item"
                                      id="alerta-excluir"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        excluirRegiaoVendedor(regiaoVendedor);
                                      }}
                                    >
                                      Excluir
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="5">
                            <ul className="pagination float-right"></ul>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default RegiaoVendedorListar;
